import React from 'react';
import { SlidersHorizontal } from 'lucide-react';

/**
 * Container for a screen's filters: a quiet surface with an optional label, wrapping filter
 * controls in a responsive row. `actions` (e.g. "Limpiar") align right.
 */
export default function FilterBar({ children, actions, label = 'Filtros', showLabel = true, className = '' }) {
    return (
        <div className={`shelf-card px-4 py-3 mb-4 ${className}`}>
            <div className="flex flex-wrap items-end gap-3">
                {showLabel && (
                    <span className="flex items-center gap-1.5 h-9 pr-1 text-[13px] font-medium text-surface-500">
                        <SlidersHorizontal className="text-[15px]" />
                        {label}
                    </span>
                )}
                <div className="flex flex-1 flex-wrap items-end gap-3 min-w-0">{children}</div>
                {actions && <div className="flex items-center gap-2 ml-auto">{actions}</div>}
            </div>
        </div>
    );
}

/** One labeled filter control inside a FilterBar. */
export function FilterField({ label, children, className = '', width }) {
    return (
        // A div (not <label>): wrapping composite controls (Select, RangePicker, Segmented) in a
        // label would forward clicks to the wrong inner element.
        <div role="group" aria-label={typeof label === 'string' ? label : undefined} className={`flex flex-col gap-1 min-w-[160px] ${className}`} style={width ? { width } : undefined}>
            {label && <span className="text-xs font-medium text-surface-500">{label}</span>}
            {children}
        </div>
    );
}
